const EXTENSION_URL_PATTERN = /^(chrome|moz|safari)-extension:\/\//;
const EXTENSION_ERROR_PATTERN = /(tronlinkParams|trap returned falsish|injected\.js)/i;

const isExtensionInjectedError = (errorLike) => {
  const message = String(errorLike?.message || errorLike?.reason?.message || errorLike || "");
  const stack = String(errorLike?.stack || errorLike?.reason?.stack || "");
  const filename = String(errorLike?.filename || "");
  const text = `${message}\n${stack}\n${filename}`;

  return (
    /tronlinkParams/i.test(text) ||
    (EXTENSION_ERROR_PATTERN.test(text) &&
      (EXTENSION_URL_PATTERN.test(filename) || EXTENSION_URL_PATTERN.test(stack)))
  );
};

export function suppressExtensionInjectedErrors() {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "error",
    (event) => {
      if (!isExtensionInjectedError(event.error || event)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (!isExtensionInjectedError(event.reason)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );
}
